var _desc, _defs, _rect, _rect2, _g, _g2, _path, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteFinder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 540",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Route finder algorithm visualization") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A stylized city route map with Dijkstra, BFS, and DFS path labels.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#082f49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312e81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "path",
    x1: 150,
    y1: 390,
    x2: 790,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22d3ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a3e635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#facc15"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 48,
    height: 48,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48",
    fill: "none",
    stroke: "#e2e8f0",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "url(#grid)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32,
    fill: "none",
    stroke: "#94a3b8",
    strokeWidth: 14,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 435C210 330 270 360 360 275S510 160 640 190s168-28 235-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 168c110 74 205 90 318 47s188 14 270 98 132 85 205 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 68c52 96 83 190 75 278s29 126 98 148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 55c-78 91-99 174-65 250s23 127-37 178"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 435C210 330 270 360 360 275S510 160 640 190s168-28 235-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 168c110 74 205 90 318 47s188 14 270 98 132 85 205 58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 68c52 96 83 190 75 278s29 126 98 148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703 55c-78 91-99 174-65 250s23 127-37 178"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 414C211 336 281 349 360 275S513 168 640 190c81 14 148-19 214-86",
    fill: "none",
    stroke: "url(#path)",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 414,
    r: 18,
    fill: "#22d3ee"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 275,
    r: 15,
    fill: "#a3e635"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 190,
    r: 15,
    fill: "#fde047"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 104,
    r: 18,
    fill: "#fb7185"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 414,
    r: 31,
    fill: "none",
    stroke: "#22d3ee",
    strokeOpacity: 0.35,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 854,
    cy: 104,
    r: 31,
    fill: "none",
    stroke: "#fb7185",
    strokeOpacity: 0.35,
    strokeWidth: 4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62 60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 152,
    rx: 20,
    fill: "#020617",
    fillOpacity: 0.72,
    stroke: "#ffffff",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 42,
    fill: "#e0f2fe",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 800
  }, "Route Finder"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 75,
    fill: "#94a3b8",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "Ulaanbaatar graph map"), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 98,
    width: 72,
    height: 30,
    rx: 15,
    fill: "#22d3ee",
    fillOpacity: 0.2,
    stroke: "#22d3ee",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 119,
    fill: "#a5f3fc"
  }, "BFS"), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 98,
    width: 72,
    height: 30,
    rx: 15,
    fill: "#a3e635",
    fillOpacity: 0.18,
    stroke: "#a3e635",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 119,
    fill: "#d9f99d"
  }, "DFS"), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 98,
    width: 44,
    height: 30,
    rx: 15,
    fill: "#facc15",
    fillOpacity: 0.18,
    stroke: "#facc15",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 207,
    y: 119,
    fill: "#fef08a"
  }, "D")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(690 374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 78,
    rx: 18,
    fill: "#020617",
    fillOpacity: 0.72,
    stroke: "#ffffff",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 32,
    fill: "#f8fafc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 800
  }, "Shortest path"), /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 58,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14
  }, "cost: optimized"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteFinder);
export default __webpack_public_path__ + "static/media/route-finder.cd6148d479ebcb298c25cf3d787569ec.svg";
export { ForwardRef as ReactComponent };